import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'
import { useTheme } from '@mui/material/styles'
import ReactMarkdown from 'react-markdown'
const PREFIX = 'LegalTemplate'
import remarkGfm from 'remark-gfm'
import { Section } from '@evocolabs/orkaui'
import theme from '@evocolabs/orkaui/lib/theme.cjs'
import Header from '@/src/components/HeaderV2'
import Footer from '@/src/components/Footer/Footer2'

const classes = {
  markdownContainer: `${PREFIX}-markdownContainer`
}

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(() => ({
  [`& .${classes.markdownContainer}`]: {
    '& ol': {
      paddingLeft: '24px'
    },

    '& a': {
      textDecoration: 'underline',
      color: theme.palette.grey[800].main,
      fontWeight: '500',
      '&:hover': {
        textDecoration: 'underline',
        color: theme.palette.grey[800].main,
        fontWeight: '500'
      },

      '&:active': {
        textDecoration: 'underline',
        color: theme.palette.grey[800].main,
        fontWeight: '500'
      },

      '&:visited': {
        textDecoration: 'underline',
        color: theme.palette.grey[800].main,
        fontWeight: '500'
      },

      '&:link': {
        textDecoration: 'underline',
        color: theme.palette.grey[800].main,
        fontWeight: '500'
      }
    },

    '& thead': {
      backgroundColor: '#F8F8F8'
    },

    '& th, table, td': {
      border: '1px solid #EAEAEA',
      borderCollapse: 'collapse'
    },

    '& td, th': {
      padding: '12px 4px'
    }
  }
}))

// const ReactMarkdown = require('react-markdown')

const LegalTemplate = ({ legalCopy }) => {
  const theme = useTheme()

  return (
    <Root>
      <Header isWhiteBg />
      <Box width="100%">
        <Section>
          <Box width="100%" className={classes.markdownContainer}>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {legalCopy}
            </ReactMarkdown>
          </Box>
        </Section>
      </Box>
      <Footer />
    </Root>
  )
}

export default LegalTemplate
